var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7319 2.73218H3.22778V3.3317H20.7319V2.73218Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4107 20.3293V20.7677H2.54883V20.3293H21.4107Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55767 4.05078L1.23975 8.1267H4.47663L6.11511 4.05078H3.55767Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43313 4.05078L7.27393 8.1267H10.4714L10.9507 4.05078H8.43313Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4822 4.05078L22.7999 8.1267H19.563L17.9246 4.05078H20.4822Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6062 4.05078L16.765 8.1267H13.5684L13.0891 4.05078H15.6062Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43515 8.73511C4.43515 9.62839 3.71107 10.3529 2.81731 10.3529C1.92379 10.3529 1.19995 9.62839 1.19995 8.73511H4.43515Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4693 8.73511C10.4693 9.62839 9.74525 10.3529 8.85173 10.3529C7.95893 10.3529 7.23389 9.62839 7.23389 8.73511H10.4693Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7257 8.73511C16.7257 9.62839 16.0011 10.3529 15.1081 10.3529C14.2148 10.3529 13.4905 9.62839 13.4905 8.73511H16.7257Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7601 8.73511C22.7601 9.62839 22.036 10.3529 21.1423 10.3529C20.2497 10.3529 19.5254 9.62839 19.5254 8.73511H22.7601Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.142 10.7147C20.2483 10.7147 19.4916 10.1195 19.2465 9.30444H17.004C16.7587 10.1195 16.0017 10.7147 15.1082 10.7147C14.214 10.7147 13.4575 10.1195 13.2124 9.30444H10.7479C10.5028 10.1195 9.74613 10.7147 8.85189 10.7147C7.95789 10.7147 7.20141 10.1195 6.95613 9.30444H4.71357C4.46829 10.1195 3.71157 10.7147 2.81757 10.7147C2.58285 10.7147 2.35821 10.6715 2.14893 10.5964V18.7417C2.14893 18.9916 2.35197 19.1948 2.60205 19.1948H21.3578C21.6079 19.1948 21.8109 18.9916 21.8109 18.7417V10.5959C21.6016 10.6712 21.377 10.7147 21.142 10.7147ZM14.2593 18.7384H9.70053V13.6516C9.70053 12.8869 10.3204 12.2672 11.0848 12.2672H12.875C13.6396 12.2672 14.2593 12.8869 14.2593 13.6516V18.7384Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/store_icon.f920f3f40e3da05726be87fd4d8fed13.svg";
export { ForwardRef as ReactComponent };